export function numberToBRL(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function BRLToNumber(value: string): number {
  return parseFloat(value.replace('R$ ', '').replace('.', '').replace(',', '.'));
}
